import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Esto funciona con bebés con reflujo?',
  a: 'Sí, el protocolo incluye ajustes de posición para bebés con sensibilidad gástrica.'
}, {
  q: '¿Tengo que comprar equipo caro?',
  a: 'No, solo necesitas tus manos y los ajustes ambientales que ya tienes en casa.'
}, {
  q: '¿Es seguro?',
  a: 'Absolutamente, se basa en principios de neonatología y respuesta sensorial básica.'
}, {
  q: '¿Cuánto tiempo tardaré en ver resultados?',
  a: 'Muchos padres reportan el cambio desde la primera noche, pero el ajuste total ocurre en los primeros 3 días.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-6 bg-brand-cream" data-id="element-15">
      <div className="max-w-3xl mx-auto" data-id="element-16">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-17">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-brown mb-4" data-id="element-18">
            Preguntas frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-19">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-white rounded-2xl border border-brand-brown/10 overflow-hidden" data-id="element-20">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none focus:bg-brand-cream/50 transition-colors" aria-expanded={openIndex === index} data-id="element-21">
                <span className="font-semibold text-brand-text pr-4" data-id="element-22">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-brand-brown transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-23" />
              </button>
              <AnimatePresence data-id="element-24">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-25">
                    <div className="px-6 pb-5 pt-1 text-brand-textLight leading-relaxed border-t border-gray-50 mx-6" data-id="element-26">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}